module.exports = __webpack_public_path__ + "img/symbol_10.82612916.png";